import { api } from '../../../app/store/api';
import { ApiResponse, PaginatedResponse } from '../../../types';
import { Discount } from '../types/discount.types';

export const discountApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getDiscountsList: builder.query<
            PaginatedResponse<unknown>,
            {
                search?: object;
                page?: number;
                perPage?: number;
            }
        >({
            query: ({ search, page, perPage = 15 }) => ({
                url: `workspace/discount`,
                method: 'GET',
                params: {
                    ...(page && { page }),
                    ...(perPage && { per_page: perPage }),
                    ...(search && {
                        search: JSON.stringify({ ...search }),
                    }),
                },
            }),
            providesTags: ['Discount'],
        }),

        storeDiscount: builder.mutation<Discount, any>({
            query: (data) => ({
                url: 'workspace/discount',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: (result) => (result ? [{ type: 'Discount' }] : []),
        }),

        updateDiscount: builder.mutation<
            string,
            Discount
        >({
            query: ({ id, ...value }) => ({
                url: `workspace/discount/${id}`,
                method: 'PATCH',
                body: value,
            }),
            invalidatesTags: (result) => (result ? [{ type: 'Discount' }] : []),
        }),

        deleteDiscount: builder.mutation<ApiResponse<unknown>, any>({
            query: (id) => ({
                url: `workspace/discount/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result) => (result ? [{ type: 'Discount' }] : []),
        }),
    }),
});

export const {
    useGetDiscountsListQuery,
    useStoreDiscountMutation,
    useUpdateDiscountMutation,
    useDeleteDiscountMutation,
} = discountApi;

export default discountApi;
